import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import {
  defaultPosition,
} from '../../components/GeneralCRUDComponent/FormFields/GoogleMapField/GoogleMapField';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import {
  translate
} from '../../helperFunctions/translation';
import {
  Branch,
  IBranchStore,
  Image,
  Image360,
  Video,
} from '../../mobx-store/storeInterfaces/branchInterface';
import {
  getDropdownLanguagesList,
  languageCodes,
} from '../../constants/languages';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  countriesIsoCodes,
} from '../../constants/countries';
import classes from './addEditBranch.module.scss';
import {
  BranchFeatureStore,
} from '../../mobx-store/stores/branchFeatureStore';

interface IProps extends WithSnackbarProps {
  branchStore: IBranchStore;
  countryStore: CountryStore;
  branchFeatureStore: BranchFeatureStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  loadingWDCBranches: boolean;
  loadingManagedCountries: boolean;
  loadingBranchFeatures: boolean;
  selectedLang: string;
  processing: boolean;
}

@inject('branchStore')
@inject('countryStore')
@inject('branchFeatureStore')
@observer
class AddEditBranch extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = false;

  branchId = -1;

  pageTitle = '';

  branchFormTitle = '';

  lastHistory = -1;

  branchSchema: any;

  submitButton: any;

  cancelButton: any;

  initImagesGallery: Image[] = [];

  initVideosGallery: Video[] = [];

  initImages360Gallery: Image360[] = [];

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.branchId = props.match.params.id;
      this.pageTitle = translate('editBranchPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addBranchPageTitle', {
      });
    }
    this.initBranchSchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.dropdownLanguages = this.getDropdownLanguages();
    this.branchFormTitle = translate('addBranchPageFormTitle', {
    });
  }

  initBranchSchema = () => {
    const schemaShape = {
      title: Yup.string()
        .required('Required'),
      description: Yup.string()
        .min(50, 'Minimum 50 characters')
        .max(1000, 'Maximum 1000 characters')
        .required('Required'),
      isWaterfront: Yup.boolean()
        .default(false),
      location: Yup.object().shape({
        latitude: Yup.number().required(),
        longitude: Yup.number().required(),
      }).required('Required'),
      images: Yup.array()
        .min(1, 'Need at least one image')
        .required('Required'),
      videos: Yup.array()
        .optional(),
      images360: Yup.array()
        .optional(),
      wdcBranch: Yup.number()
        .required('Required'),
      backgroundImage: Yup.array()
        .required('Required'),
      masterPlanImage: Yup.array()
        .required('Required'),
      features: Yup.array()
        .optional(),
    };
    if (!this.isEgypt) {
      delete schemaShape.wdcBranch;
    }
    this.branchSchema = Yup.object().shape(schemaShape);
  }

  componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.setState({
        loadingManagedCountries: false,
      });
      this.forceUpdate();
      this.getWDCBranches(this.state.selectedLang);
      this.populateBranchFeaturesFieldList(this.state.selectedLang);
      if (!this.isNew) {
        this.getBranch(this.state.selectedLang);
      }
    }
  }

  getFormFields = (): FormField[] => {
    const formFields: FormField[] = [
      {
        name: 'title',
        label: this.isNew && this.isEgypt ? translate('addBranchPageFormArabicName', {}) : translate('addBranchPageFormEnglishName', {}),
        type: 'text',
        filedType: 'InputField',
        value: (this.isNew ? '' : this.props.branchStore.selectedBranch.getTitle()),
      },
      {
        name: 'isWaterfront',
        activeLabel: translate('addBranchPageFormWaterfrontType', {}),
        inactiveLabel: translate('addBranchPageFormClubType', {}),
        filedType: 'ToggleButtonField',
        value: (this.isNew ? false : this.props.branchStore.selectedBranch.getIsWaterfront()),
      },
      {
        name: 'description',
        label: this.isNew && this.isEgypt
          ? translate('addBranchPageFormArabicDescription', {}) : translate('addBranchPageFormEnglishDescription', {}),
        type: 'text',
        filedType: 'InputField',
        value: (this.isNew ? '' : this.props.branchStore.selectedBranch.getDescription()),
      },
      {
        name: 'masterPlanImage',
        label: translate('addBranchPageFormMasterPlanImage', {}),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        textMessage: translate('addBranchPageFormMasterPlanTextMessage', {}).replace('_SIZE_', '5120'),
        warningMessage: translate('addBranchPageFormMasterPlanWarningMessage', {}),
        value: (this.isNew ? [] : this.props.branchStore.selectedBranch.getMasterPlanImage()),
        size: 5120,
      },
      {
        name: 'location',
        label: translate('addBranchPageFormBranchLocation', {}),
        filedType: 'GoogleMapField',
        value: (this.isNew ? defaultPosition : this.props.branchStore.selectedBranch.getLocation()),
      },
      {
        name: 'wdcBranch',
        label: translate('addBranchPageFormWdcBranch', {}),
        selectList: [],
        selectListValue: 'title',
        selectListKey: 'wcdBranchId',
        filedType: 'DropdownField',
        value: (this.isNew ? -1 : this.props.branchStore.selectedBranch.getWdcBranch()),
      },
      {
        name: 'backgroundImage',
        label: translate('addBranchPageFormBackgroundImage', {}),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        value: (this.isNew ? [] : this.props.branchStore.selectedBranch.getBackgroundImage()),
        size: 512,
      },
      {
        name: 'images',
        label: translate('addBranchPageFormGalleryImages', {}),
        filedType: 'GalleryField',
        accept: 'image/*',
        value: (this.isNew ? [] : this.props.branchStore.selectedBranch.getImages()),
        size: 512,
      },
      {
        name: 'videos',
        label: translate('addBranchPageFormGalleryVideos', {}),
        filedType: 'GalleryField',
        accept: 'video/*',
        size: 10240,
        value: (this.isNew ? [] : this.props.branchStore.selectedBranch.getVideos()),
      },
      {
        name: 'images360',
        label: translate('addBranchPageFormGalleryImages360', {}),
        filedType: 'GalleryField',
        accept: 'image/*',
        size: 5120,
        value: (this.isNew ? [] : this.props.branchStore.selectedBranch.getImages360()),
      },
      {
        name: 'features',
        label: translate('addBranchPageFormFeatures', {}),
        filedType: 'MultipleSelectField',
        selectList: [],
        selectListValue: 'title',
        selectListKey: 'branchFeatureId',
        value: (this.isNew ? [] : this.props.branchStore.selectedBranch.getFeatures()),
      },
    ];
    if (this.isEgypt) {
      return formFields;
    }
    return formFields.filter((formField: FormField) => {
      return formField.name !== 'wdcBranch';
    });
  };

  initState = (isConstructor = true) => {
    const initState: IState = {
      processing: false,
      selectedLang: languageCodes.english,
      loading: !this.isNew,
      loadingWDCBranches: true,
      loadingManagedCountries: true,
      loadingBranchFeatures: true,
      formFields: this.getFormFields(),
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  getBranchFormValues = (values: any) => {
    const branch = new Branch();
    branch.setBackgroundImage(values);
    branch.setTitle(values.title);
    branch.setDescription(values.description);
    branch.setIsWaterfront(values.isWaterfront);
    branch.setImages(values.images);
    branch.setVideos(values.videos);
    branch.setImages360(values.images360);
    branch.setBackgroundImage(values.backgroundImage);
    branch.setMasterPlanImage(values.masterPlanImage);
    branch.setLocation(values.location);
    branch.setWdcBranch(values.wdcBranch);
    branch.setFeatures(values.features);
    branch.availableCountries = values.availableCountries;
    return branch;
  };

  handelSubmit = (values: any): void => {
    const {
      countryStore,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);

    this.setState({
      processing: true,
    });
    if (this.isNew) {
      const newBranch = this.getBranchFormValues(values);
      // add default wdcbranch value = 0 for kenya branches
      if (!this.isEgypt) {
        newBranch.wdcBranch = 0;
      }
      if (newBranch.wdcBranch === -1) {
        this.setState({processing: false});
        SnackBarComponent.getInstance().openSnackbar(translate('wdcBranchRequiredErrorMessage', {}), 5000, 'error');
        return;
      }
      this.props.branchStore.createBranch(newBranch)
        .then((res: any) => {
          if (this.isEgypt) {
            this.props.history.push(`${res.branchId}/edit`);
          } else {
            this.props.history.push('/branches');
          }

          SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {}), 5000, 'success');
        }).catch((error) => {
          this.setState({processing: false});
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {}), 5000, 'error');
        });
    } else {
      const updatedBranch = this.getBranchFormValues(values);
      // add default wdcbranch value = 0 for kenya branches
      if (!this.isEgypt) {
        updatedBranch.wdcBranch = 0;
      }
      this.props.branchStore.updateBranch(
        updatedBranch, this.branchId, this.initImagesGallery, this.initVideosGallery,
        this.initImages360Gallery, this.state.selectedLang,
      )
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 5000, 'success');
          this.props.history.push('/branches');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    }
  };

  handelCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handelSubmit,
  });

  handelLanguageChange = (langCode: string) => {
    if (langCode !== this.state.selectedLang) {
      this.getWDCBranches(langCode, this.props.branchStore.selectedBranch.getWdcBranch());
      if (this.isNew) {
        this.setState({
          selectedLang: langCode,
        });
      } else {
        this.getBranch(langCode);
      }
    }
  };

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handelCancel,
  });

  updateStateWithWDCBranchesData = () => {
    const formFieldsWithData: FormField[] = [];
    this.state.formFields.forEach((field: FormField) => {
      if (field.name === 'wdcBranch') {
        formFieldsWithData.push(
          {
            ...field, selectList: this.props.branchStore.wdcBranchesList,
          },
        );
      } else {
        formFieldsWithData.push(field);
      }
    });
    this.setState({
      formFields: formFieldsWithData,
      loadingWDCBranches: false,
    });
  };

  populateBranchFeaturesFieldList = async (langCode: string) => {
    this.setState({
      loadingBranchFeatures: true,
    });
    await this.props.branchFeatureStore.getBranchFeaturesList(langCode);
    const formFieldsWithData = [...this.state.formFields];
    formFieldsWithData.forEach((field: any) => {
      if (field.name === 'features') {
        field.selectList = this.props.branchFeatureStore.BranchFeaturesList;
      }
    });
    this.setState({
      formFields: formFieldsWithData, loadingBranchFeatures: false,
    });
  };

  updateStateWithBranchData = () => {
    const formFieldsWithData = this.getFormFields();
    this.initImagesGallery = Object.assign([], this.props.branchStore.selectedBranch.images);
    this.initVideosGallery = Object.assign([], this.props.branchStore.selectedBranch.videos);
    this.initImages360Gallery = Object.assign([], this.props.branchStore.selectedBranch.images360);
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {
            this.state.loading || this.state.loadingWDCBranches || this.state.loadingManagedCountries || this.state.loadingBranchFeatures
              ? <Spinner />
              : (
                <GeneralFormComponent
                  dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                  formTitle={this.branchFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.branchSchema}
                  submitButton={this.submitButton}
                  processing={this.state.processing}
                  cancelButton={this.cancelButton}
                />
              )
          }
        </div>
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
    } = this.props;
    await countryStore.getUserManagedCountries();
    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }
    this.initState(false);
    this.submitButton = this.getSubmitButton();

    if (this.isEgypt) {
      this.getWDCBranches(this.state.selectedLang);
    }

    if (this.isNew) {
      await this.populateBranchFeaturesFieldList(this.state.selectedLang);
    } else {
      this.getBranch(this.state.selectedLang);
    }

    this.setState({
      loadingManagedCountries: false,
      loadingWDCBranches:false,
    });
  }

  getBranch = (langCode: string) => {
    this.setState({
      loading: true,
    });
    this.props.branchStore.getBranchById(this.branchId, langCode)
      .then(async () => {
        const wdcBranch = this.props.branchStore.selectedBranch.getWdcBranch();
        await this.getWDCBranches(this.state.selectedLang, wdcBranch);
        this.updateStateWithBranchData();
        await this.populateBranchFeaturesFieldList(this.state.selectedLang);
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
  };

  getWDCBranches = (langCode: string, selectedWdcBranch = -1) => {
    this.setState({
      loadingWDCBranches: true,
    });
    this.props.branchStore.getWDCBranches(langCode, selectedWdcBranch)
      .then(() => {
        this.updateStateWithWDCBranchesData();
      }).catch(() => {
        this.setState({
          loadingWDCBranches: false,
        });
      });
  };
}

export default withRouter(AddEditBranch);
